<div class="design-dimensions-container" *ngIf="designDimensions">
	<div class="fields-container">
		<ie-form-field [label]="'PROJECT_WIDTH' | translate">
			<input
				[(ngModel)]="designDimensions.width"
				type="number" class="ie-form-field-styling" name="dd_width" (change)="onDimensionChanged('w')" />
		</ie-form-field>
		<div class="ie-icon-button" (click)="aspectRatioLocked = !aspectRatioLocked" [title]="(aspectRatioLocked ? 'UN' : '') + 'LOCK_ASPECT_RATIO' | translate">
			<i class="fa lock-aspect-ratio" [ngClass]="{'fa-chain': aspectRatioLocked, 'fa-chain-broken': !aspectRatioLocked}"></i>
		</div>
		<ie-form-field [label]="'PROJECT_HEIGHT' | translate">
			<input
				[(ngModel)]="designDimensions.height"
				type="number" class="ie-form-field-styling" name="dd_height" (change)="onDimensionChanged('h')" />
		</ie-form-field>
	</div>

	<div class="button-bar">
		<div class="reset-button bar-button" (click)="onResetClick()">
			{{ (isApp ? 'RESET_TO_TEMPLATE_DIMENSIONS' : 'RESET_TO_MEDIA_DIMENSIONS') | translate }}
		</div>
		<div class="bar-button" (click)="closeModal()">
			{{ 'CANCEL' | translate }}
		</div>

		<div class="ok-button bar-button" (click)="onOkClick()">
			{{ 'OK' | translate }}
		</div>
	</div>
</div>
